export default {"src":"/_next/static/media/exchange.cf1dbfdf.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};